document.addEventListener('DOMContentLoaded', function () {
  var stickyBars = document.querySelectorAll('.product-sticky');
  if (!stickyBars.length) return;

  stickyBars.forEach(function (sticky) {
    sticky.classList.remove('active');

    var showOffset = 1200;

    if (sticky.classList.contains('product-sticky--call-offer')) {
      showOffset = 1200;
    }

    function onScroll() {
      if (window.scrollY > showOffset) {
        sticky.classList.add('active');
      } else {
        sticky.classList.remove('active');
      }
    }

    onScroll();

    window.addEventListener('scroll', onScroll);
  });
});
